    import { createRouter, createWebHistory } from 'vue-router';
    import store from '../store';
    import api from '@/api/api';
    import commonRoutes from "./routes/common"
    import { updateRoutesBasedOnUserRole } from './dynamic-route';
    import {SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD} from "@/store/types/root/mutations-types"
    let routes = commonRoutes
    // const currentUser = store.state.auth.user_type
    //  const currentUser = localStorage.getItem("userType");
    const router = new createRouter({
        // mode: 'history',
        history: createWebHistory(),
        linkExactActiveClass: 'active',
        routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            } else {
                return { left: 0, top: 0 };
            }
        },
    });

    updateRoutesBasedOnUserRole(router, localStorage.getItem("userType"))

    router.beforeEach((to, from, next) => {
        
        let currentUser =  localStorage.getItem("userType")
        if(currentUser + "".length < 4){
            currentUser = store.state.auth.user_type;
        }
        // console.log("Going from ", from, " to ", to)
        api.defaults.headers['Authorization'] = localStorage.getItem("IdToken");


        //set authenticated on page force reload
        if(localStorage.getItem("IdToken") !== null){

            if(localStorage.getItem("IdToken").length > 5){
                store.commit(SET_AUTHENTICATED_PAGE_ON_FORCE_RELOAD, {});

                // authenticate user force refresh, redirect back to the old page
                if(from.name === undefined && to.path === "/"){
                    router.push({ name: "leaderboard" });  
                }
        }
    }
            
        if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
            store.commit('setLayout', 'auth');
        } else {
            store.commit('setLayout', 'app');
            
            if (to.name === 'login') {
                next(); // Proceed with the navigation
            } else if(!store.getters.isAuthenticated){
                store.commit('setLayout', 'auth');
                next({ name: 'login' }); // Redirect to the login page
            }
        }

        // roles based authentication
        if (to.meta.requiresAuth) {
            // Route requires authentication
            // console.log("Current user:", currentUser, "Role is : ", to.meta.role)
            if (currentUser) {
            // User is logged in
            if (to.meta.role === currentUser || to.meta.role === "common") {
                // console.log("Matched role")
                // User's role matches the required role for this route
                next(); // Allow access to the route
            } else {
                // User's role does not match the required role for this route
                // Redirect them to the appropriate route based on their role
                // console.log("did not match role.")
                next({ path: '/login' });
            }
            } else {
            // User is not logged in, redirect them to the login page or a default page
            // next({ path: '/login' });
            }
        } else {
            // Route does not require authentication, allow access
            next();
        }
        // ends here
        // next(true);
    });

    export default router;
